@if (loading) {
    <div class="loading-cotainer">
        <spinner-overlay [overlay]="true"></spinner-overlay>
    </div>
}@else {
    <table mat-table [dataSource]="datasource" matSort (matSortChange)="sortChange($event)">
    @for (column of columns; track column; let i = $index) {
        <ng-container matColumnDef="{{column}}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{headings[i]}} </th>
        <td mat-cell *matCellDef="let element">
            @if (column === 'icon') {
                <app-node-svg [type]="element.node.type"/>
            }@else if (column === 'name') {
            {{element[column]}}
            }@else if (column === 'model') {
            {{element[column]?.name||''}}
            }@else if (column === 'frequency') {
            <button mat-button color="accent" (click)="openFrequencyDialog(element)" style="align-items: left;align-content: left;text-align: left;">
                {{element[column]}}
            </button>
            }@else if (column === 'information') {
            {{element.information?element.information.join(', '):''}}
            }@else if (column === 'Cost') {
            {{element.insightsValues[column] | currency: linqset.organisation.currencyCode||'NZD': 'symbol-narrow': '1.0-0'}}
            }@else {
            {{element.insightsValues[column] | number}}
            }
        </td>
        </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columns; sticky:true"></tr>
    <tr mat-row *matRowDef="let element; columns: columns;" (click)="selectRow(element); $event.stopPropagation()"></tr>
    </table>
}